import config from '@/config';
import {ApiBase, InternationalizedField} from '@/api/common';
import PointsMetric from "@/api/metricPoints";
import Phoneme from "@/api/phoneme";

const NO_UPLOAD_FIELDS = [
    'audio_path',
    'audio_link',
    'audio_file',
    'audio_alt_path',
    'audio_alt_link',
    'audio_alt_file',
    'state',
];

export default class NextExercise extends ApiBase<NextExercise> {
    public static readonly SLUG: string = 'nextexercise';
    private static readonly URL_BASE: string = config.API_ROOT + '/next-exercise/';


    public condition_type?: string = 'DEFAULT';
    public condition_value?: string = undefined;
    public exercise?: number = undefined;
    public parent_id?: number = undefined;
    public text_i18n?: InternationalizedField<string> =  new InternationalizedField<string>();
    public lesson?: number = 0;
    public audio?: number = undefined;
    public audio_path?: string = undefined;
    public audio_link?: string = undefined;
    public audio_alt?: number = undefined;
    public audio_alt_path?: string = undefined;
    public audio_alt_link?: string = undefined;
    public points?: number = undefined;
    public points_2?: number = undefined;
    public metric_points?: PointsMetric[] = [];


    public parent_model?: string = undefined;

    // used to know if the hint is being created, was updated or is saved
    public state?: string = 'created';

    // used to store the files before the hint is uploaded
    // null means the user deleted the current image and did not replaced it
    public audio_alt_file?: File|null = undefined;
    public audio_file?: File|null = undefined;

    public constructor() {
        super({
            urlBase: NextExercise.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }

    public assign(response: any): NextExercise {
        super.assign(response);
        if (response) {
            if ('metric_points' in response) {
                this.metric_points = [];
                response.metric_points.forEach((p_m: any) => {
                    this.metric_points.push(new PointsMetric().assign(p_m));
                });
            }
            if ('text_i18n' in response) {
                this.text_i18n = new InternationalizedField<string>(response.text_i18n);
            }
        }

        this.state = 'unchanged';
        return this;
    }
}
